import React from 'react';

import { LayoutGridItem } from '@cko/primitives';
import { ContentAreas } from '../../../types/contentAreas';

type Props = {
  contentAreas: ContentAreas;
};

export const SingleViewLayout = ({ contentAreas }: Props) => {
  const { main } = contentAreas;

  return <LayoutGridItem span={24}>{main}</LayoutGridItem>;
};
